import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';
import JsonLd from '../../Common/JsonLd';

const dycFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Donate Your Card?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Donate Your Card lets you turn unused or partially used retail gift card balances into charitable donations. We partner with a leading gift card exchange to convert the balance into cash for a donation."
      }
    },
    {
      "@type": "Question",
      "name": "Are retail gift card donations tax-deductible?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. When you donate a retail gift card, you receive an official 100% tax receipt for the cash amount generated from the card conversion."
      }
    },
    {
      "@type": "Question",
      "name": "What kinds of store gift cards can I donate?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can donate gift cards from hundreds of popular retailers, restaurants, and department stores, including Target, Starbucks, Walmart, Amazon, Home Depot, and many more."
      }
    },
    {
      "@type": "Question",
      "name": "What are the minimum balance requirements to donate a gift card?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most retailers require a minimum balance of $10 to $15 to qualify for conversion."
      }
    }
  ]
};

function DYCFaqs() {
    return (
        <section>
            <JsonLd schema={dycFaqSchema} />
            <Container>
                <Row>
                    <Col xs="12" className="justify-content-center text-center mt-4 mb-2">
                        <h1>Frequently Asked Questions</h1>
                    </Col>
                    <div className="container-fluid">
                        <div className="text-center">
                            <h3>
                                Donate Your Card - Donate Unused Balances of Retail Gift Cards
                            </h3>
                        </div>
                        <p>
                            CharityChoice has been a leader in opening innovative new channels for charitable giving, since creating the
                            original nonprofit charity gift card.</p>
                        <ul>
                            <li>Launched the first nonprofit 'Donate Your Card' program, allowing people to turn unused retail gift
                                card balances into cash donations for the charities of their choice.</li>
                        </ul>
                        <p>
                            Our mission is to make generosity simple, meaningful, and part of everyday life to benefit causes that help
                            make a better world.
                        </p>
                        <h3>About</h3>
                        <ul>
                            <li>
                                <span className={styles.boldInfoMessage}>
                                    CharityChoice
                                </span>
                                <div>
                                    The nonprofit pioneer enabling the donation of unused gift card balances.
                                    <br />
                                    Creating a new channel to benefit charitable causes The 'Donate Your Card' program allows you to turn unused retail gift cards balances - for hundreds of popular stores and restaurants -  into meaningful cash donations. Through our partnership with a leading gift card exchange, donated cards are converted into cash, at a favorable rate so charities receive the maximum possible benefit. Your donation is tax-deductible, and you may choose up to three charities from our list of more than 2,500 carefully vetted nonprofit organizations.
                                </div>
                            </li>
                        </ul>
                        <div className={styles.faqsContent}>
                            <h3 style={{ padding: "20px", textDecoration: "none" }}>
                                Donate Your Card FAQs
                            </h3>
                            <ul>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        What is Donate Your Card?
                                    </span>
                                    <div>
                                        Donate Your Card lets you turn unused or partially used retail gift card balances into charitable donations. We partner with a leading gift card exchange to convert the balance into cash for a donation.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Are retail gift card donations tax-deductible?
                                    </span>
                                    <div>
                                        Yes. Donations are tax-deductible, and you will receive a receipt for the full face value or 100% of the remaining balance of the card. Please consult your tax advisor regarding deductions and your specific tax situation.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        What happens to my donated gift card?
                                    </span>
                                    <div>
                                        The card is transferred to a leading gift card exchange at a favorable bulk rate and converted into cash for distribution to the charity or charities you choose.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Can I still use my gift card after donating it?
                                    </span>
                                    <div>
                                        No. Once the card is donated, you should not use it. Wait for our final verification email with instructions to securely destroy the card.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        How many charities can I support with my donated card?
                                    </span>
                                    <div>
                                        You may choose up to three charities from our list of more than 2,500 carefully vetted nonprofit organizations.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        What if I donate through a charity's link?
                                    </span>
                                    <div>
                                        If you reach our site through a charity partner's link, your donation will automatically be directed to that charity.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        How and when do charities receive the funds?
                                    </span>
                                    <div>
                                        Funds are distributed quarterly.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Is my personal information shared with the charity?
                                    </span>
                                    <div>
                                        It's completely up to you. During the donation process, you will have the option to share your information with the charity or decline and remain anonymous.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Does CharityChoice deduct any fees from the resale value?
                                    </span>
                                    <div>
                                        Yes. CharityChoice/Special Kids Fund, our 501(c)(3) nonprofit, deducts a 10% fundraising cost from the resale value of your card. This covers the various costs of running the Donate Your Card program and benefits underprivileged special needs children.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Can any charity receive these funds?
                                    </span>
                                    <div>
                                        Funds may only be designated to organizations registered on our approved charity list.
                                    </div>
                                </li>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Can I reverse a donated retail gift card?
                                    </span>
                                    <div>
                                        Yes. You can decline the donation upon receipt of the final verification email. If not done immediately at that time, the donation of your retail gift card becomes non-revocable.
                                    </div>
                                </li>
                            </ul>
                            <h3 style={{ padding: "20px", textDecoration: "none" }}>
                                Donate Your Card Terms And Conditions
                            </h3>
                            <ul>
                                <li>
                                    <span className={styles.boldInfoMessage}>
                                        Donate Your Card Terms and Conditions
                                    </span>
                                    <div>
                                        Donated retail gift cards are converted at a favorable bulk rate through our resale partner, a leading gift card exchange, which provides the cash value for distribution to the charities you select. Donations of retail gift cards are non-revocable once finalized, as the value is transferred to a leading gift card exchange. CharityChoice/Special Kids Fund, a registered 501(c)(3) nonprofit organization, deducts a 10% fundraising cost. Funds are allocated to the designated charities on a quarterly basis. Only organizations listed on our carefully vetted list of 2,500 charities are eligible to receive funds from your donation. We provide a confirmation which is also a tax acknowledgement for 100% of the balance on your card,  Please consult your tax advisor regarding your deduction and individual tax situation.
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>
    );
}

export default DYCFaqs;